import { useApp } from '../AppContext';
import './FeedTab.css';

export default function FeedTab() {
  const { friends, forgiven, user, setTab } = useApp();

  const now = new Date();
  const dateLabel = now.getHours() >= 18 ? 'Tonight' : `${now.toLocaleDateString('en-US', { weekday: 'long' })} night`;

  // Build feed: mutual friends who forgave + current user if they forgave
  const feedItems = [];
  if (forgiven && user) {
    feedItems.push({ id: 'me', name: 'You', initials: user.initials, time: 'Just now' });
  }
  friends.filter(f => f.forgiven).forEach(f => feedItems.push(f));

  return (
    <div className="feed-tab">
      <div className="feed-date">{dateLabel}</div>

      {feedItems.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">☽</div>
          <div className="empty-title">Quiet tonight</div>
          <div className="empty-sub">"It is as you have seen, except that I do not find fraud in my soul towards the Muslims."</div>
          <div className="empty-ref">A man of Paradise · Musnad Ahmad 12286</div>
          <button className="btn-ghost" style={{ marginTop: 8 }} onClick={() => setTab('friends')}>
            Invite your circle →
          </button>
        </div>
      ) : (
        <ul className="feed-list">
          {feedItems.map((item, i) => (
            <li key={item.id} className="feed-item" style={{ animationDelay: `${i * 0.05}s` }}>
              <div className="avatar feed-avatar">{item.initials}</div>
              <div className="feed-info">
                <div className="feed-name">{item.name}</div>
                <div className="feed-action">forgave everyone tonight 🤍</div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
